//import defaultInfoResellers from './../default.json';
import { call, all, fork, put, takeEvery } from 'redux-saga/effects';
import {
  GET_RESELLER_INFO
} from 'Redux/actionTypes';
import { endpoints } from 'Core/defaultValues';
import {
  setLegacyUrl
} from 'Core/data/Helpers';

//actions
import {
  getResellerInfoResult
} from 'Redux/actions';
import { ExceptionManager } from 'Core/logManager';
import axios from 'axios';
export function* getResellerInfo({ payload }) {
  const { type, value } = payload;
  let reseller;
  try {
    reseller = yield call(async () => {
      try {
        const requestOptions = {
          method: "POST",
          redirect: "follow",
          body: JSON.stringify({ code: type === 'key' ? value : null })
        };
        
        const response = await fetch(`${process.env.PM_API_GATEWAY}/stage/brand/searchBrand`, requestOptions)
          .then((response) => response.json())
          .catch((error) => { throw error; });
        return response;
      } catch (error) {
        ExceptionManager(error, 'Core/views/login/redux', 'Error fetching reseller info:');
        throw error; // Re-throw the error to be handled by the saga's try-catch
      }
    });
  } catch (exc) {
    // catch throw
    ExceptionManager(exc, 'Core/resellers/redux', 'getResellerInfoResult');
    localStorage.setItem("legacyUrl", null);
    yield put(getResellerInfoResult(null));
  }
  if (reseller) {
    localStorage.setItem("legacyUrl", setLegacyUrl(endpoints.LEGACY_URL, reseller));
    reseller = { ...reseller, legacyUrl: setLegacyUrl(endpoints.LEGACY_URL, reseller) };
    yield put(getResellerInfoResult({
      reseller,
      type
    }));
  } else {
    yield put(getResellerInfoResult(null));
    localStorage.setItem("legacyUrl", null);
  }
  
}


function* watchResellerInfo() {
  yield takeEvery(GET_RESELLER_INFO, getResellerInfo);
}

//merge sagas
export default function* rootSaga() {
  yield all([
    fork(watchResellerInfo)

  ]);
}
